import { Injectable } from '@angular/core';
import { UserService } from '../user.service';
import { LogLevel } from './log-level.enum';
import { LogPublisher } from './log-publishers';
import { NGaugeService } from './ngauge.service';

@Injectable()
export class LogService {
  level: LogLevel = LogLevel.All;
  logWithDate = true;
  publishers: LogPublisher[];

  constructor(
    private userService: UserService,
    private ngaugeService: NGaugeService) {
  }

  debug(msg: any, url: any, ...optionalParams: any[]) {
    this.writeToLog(msg, url, LogLevel.Debug, optionalParams);
  }

  info(msg: any, url: any, ...optionalParams: any[]) {
    this.writeToLog(msg, url, LogLevel.Info, optionalParams);
  }

  warn(msg: any, url: any, ...optionalParams: any[]) {
    this.writeToLog(msg, url, LogLevel.Warn, optionalParams);
  }

  error(msg: any, url: any, ...optionalParams: any[]) {
    this.writeToLog(msg, url, LogLevel.Error, optionalParams);
  }

  fatal(msg: any, url: any, ...optionalParams: any[]) {
    this.writeToLog(msg, url, LogLevel.Fatal, optionalParams);
  }

  log(msg: any, url: any, ...optionalParams: any[]) {
    this.writeToLog(msg, url, LogLevel.All, optionalParams);
  }

  private writeToLog(msg: any, url: any, level: LogLevel, params: any[]) {
    if (this.shouldLog(level)) {
      let entry: any;
      entry = { ...msg };
      entry.level = LogLevel[level];
      for (const logger of this.publishers) {
        logger.log(entry, url).subscribe();
      }
    }
  }

  private shouldLog(level: LogLevel): boolean {
    let ret = false;
    if ((level >= this.level &&
      level !== LogLevel.Off) ||
      this.level === LogLevel.All) {
      ret = true;
    }
    return ret;
  }

  logUserActivityWithEmail(logLevel, email, whereArise, whatEnsue) {
    const params = {
      createdBy: email,
      whereArise,
      whatEnsue,
      whenOccur: new Date(),
      logActivity: true,
      logFieldHistory: false,
      logErr: false
    };
    this[logLevel](params, this.ngaugeService.meldURL);
  }

  logUserActivity(logLevel, whereArise, whatEnsue) {
    const params = {
      createdBy: this.userService.getLoggedInUserName(),
      whereArise,
      whatEnsue,
      whenOccur: new Date(),
      logActivity: true,
      logFieldHistory: false,
      logErr: false
    };
    this[logLevel](params, this.ngaugeService.meldURL);
  }

  logFieldHistory(logLevel, whereArise, screen, field, oldVal, newVal) {
    oldVal = (oldVal === true || oldVal === 'true') ? 'Checked' :
      ((oldVal === false || oldVal === 'false') ? 'Unchecked' : oldVal);
    newVal = (newVal === true || newVal === 'true') ? 'Checked' :
      ((newVal === false || newVal === 'false') ? 'Unchecked' : newVal);
    const params = {
      createdBy: this.userService.getLoggedInUserName(),
      whereArise,
      screen,
      field,
      oldVal,
      newVal,
      whenOccur: new Date(),
      logActivity: false,
      logFieldHistory: true,
      logErr: false
    };
    this[logLevel](params, this.ngaugeService.meldURL);
  }

  logFieldHistorySystemUpdate(logLevel, createdBy, whereArise, screen, field, oldVal, newVal) {
    oldVal = (oldVal === true || oldVal === 'true') ? 'Checked' :
      ((oldVal === false || oldVal === 'false') ? 'Unchecked' : oldVal);
    newVal = (newVal === true || newVal === 'true') ? 'Checked' :
      ((newVal === false || newVal === 'false') ? 'Unchecked' : newVal);
    const params = {
      createdBy,
      whereArise,
      screen,
      field,
      oldVal,
      newVal,
      whenOccur: new Date(),
      logActivity: false,
      logFieldHistory: true,
      logErr: false
    };
    this[logLevel](params, this.ngaugeService.meldURL);
  }

  logError(logLevel, screen, whereArise, message) {
    const params = {
      createdBy: this.userService.getLoggedInUserName(),
      screen,
      whereArise,
      message,
      whenOccur: new Date(),
      logActivity: false,
      logFieldHistory: false,
      logErr: true
    };
    this[logLevel](params, this.ngaugeService.meldURL);
  }
}

export class LogEntry {
  level: string = LogLevel[LogLevel.Debug];
}



// WEBPACK FOOTER //
// ./src/app/services/shared/log.service.ts